import { useFlag } from '@/features/unleash';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

interface Props {
  onClick: () => void;
}

const BlackCloseIcon = ({ onClick }: Props) => (
  <div className="cursor-pointer absolute right-2 top-2 z-[1]">
    <CrossSolid fill="black" data-cy-id="close-button" onClick={onClick} />
  </div>
);

const WhiteCloseIcon = ({ onClick }: Props) => (
  <div className="cursor-pointer absolute right-2 top-2 z-[1]">
    <CrossSolid fill="white" data-cy-id="close-button" onClick={onClick} />
  </div>
);

export const CloseIcon = ({ onClick }: Props) => {
  const { variant } = useFlag({ name: 'mono-signup-wall' });

  if (variant.name === 'variant-dark') {
    return (
      <>
        <div className="block lg:hidden">
          <WhiteCloseIcon onClick={onClick} />
        </div>
        <div className="hidden lg:block">
          <BlackCloseIcon onClick={onClick} />
        </div>
      </>
    );
  }

  return <BlackCloseIcon onClick={onClick} />;
};
